import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const formatDuration = (seconds) => {
  let sec = seconds;
  if (sec < 0) sec = 0;
  const h = Math.floor(sec / 3600)
    .toString()
    .padStart(2, "0");
  const m = Math.floor((sec % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(sec % 60)
    .toString()
    .padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export const getDeviceOffsetMin = (offsetMsk) =>
  (3 + (parseInt(offsetMsk, 10) || 0)) * 60;

export const getFakeLocalDate = (isoOrDate, offsetMsk) => {
  if (!isoOrDate) return new Date();
  const d = dayjs(isoOrDate).utcOffset(getDeviceOffsetMin(offsetMsk));
  return new Date(
    d.year(),
    d.month(),
    d.date(),
    d.hour(),
    d.minute(),
    d.second(),
  );
};

export const fromFakeLocalToUtcIso = (fakeDate, offsetMsk) => {
  if (!fakeDate) return null;
  const offsetMin = getDeviceOffsetMin(offsetMsk);
  const utcMs = Date.UTC(
    fakeDate.getFullYear(),
    fakeDate.getMonth(),
    fakeDate.getDate(),
    fakeDate.getHours(),
    fakeDate.getMinutes(),
    fakeDate.getSeconds(),
  );
  return new Date(utcMs - offsetMin * 60000).toISOString();
};